import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import type { GetGSEmailList, GSEmailList } from './types';
import type { Paginator } from '../../../../Nomination/graphql';
import {
  modeOfStudyOptions,
  programmeTypeOptions,
} from '../../../../Application/components';
import { MONITOR_LIST_TEXT } from '../../../lang';
import { getOptionsLabel } from '../../../../Monitor/components';

export const GS_GET_EMAIL_LIST = gql`
  query (
    $filter: OfferedApplicationFilter!
    $sort: OfferDetailSorter
    $paginator: PaginatorOptions
  ) {
    offerList(filter: $filter, sort: $sort, paginator: $paginator) {
      data {
        applicationId
        applicationNo
        applicantName
        programme
        researchArea
        studyMode
        entryYear
        programmeType
        programmeCode
        programmeSubcode
        # programmeWithDuration
        department
        supervisor
        proposedChiefSupervisor
        # duration
        status
        isFirmOffer
        releaseDate
      }
      paginator {
        count
        total_pages
      }
    }
  }
`;

const PROGRAMME_LEVEL = MONITOR_LIST_TEXT.PROGRAMME_LEVEL;

export const useGetEmailList = (
  filter: any,
  sort: any,
  paginator: Paginator,
): GetGSEmailList => {
  const { data, loading, error, refetch } = useQuery(GS_GET_EMAIL_LIST, {
    variables: { filter, sort, paginator },
    fetchPolicy: 'network-only',
  });

  let emailListData: GSEmailList = {
    emailList: [],
    totalPage: 1,
    count: 0,
  };
  if (!loading) {
    const offerList = data?.offerList?.data ?? [];
    const emailList = offerList.map((element: any) => {
      const {
        applicationId,
        applicationNo,
        applicantName,
        programme,
        researchArea,
        studyMode,
        entryYear,
        programmeType,
        programmeCode,
        programmeSubcode,
        // programmeWithDuration,
        department,
        supervisor,
        proposedChiefSupervisor,
        // duration, // TODO: duration is not used in the email list temporarily
        status,
        isFirmOffer,
        releaseDate,
      } = element;

      const studyModeLabel = getOptionsLabel(modeOfStudyOptions, studyMode);
      const programmeTypeLabel = getOptionsLabel(
        programmeTypeOptions,
        programmeType,
      );

      return {
        applicationId,
        applicationNo,
        applicantName,
        progLevel: PROGRAMME_LEVEL[programme as keyof typeof PROGRAMME_LEVEL],
        researchField: researchArea,
        studyMode: studyModeLabel,
        department,
        proposedChiefSupervisor:
          supervisor +
          `${(proposedChiefSupervisor as boolean) ? '(' + proposedChiefSupervisor + ')' : ''}`,
        // duration: Number(duration ?? 0),
        entryYear,
        programmeCode,
        programmeSubcode,
        progType: programmeTypeLabel ?? 'N/A',
        status,
        isFirmOffer,
        releaseDate,
      };
    });
    const totalPage = data?.offerList?.paginator?.total_pages ?? 1;
    const count = data?.offerList?.paginator?.count ?? 0;

    emailListData = {
      emailList,
      totalPage,
      count,
    };
  }

  return { emailListData, loading, error, refetch };
};
